// plan-04 S01: content-hash codec — 6-char base32 round-trip for (x,y,z,a) indices

import { SLOT_X, SLOT_Y, SLOT_Z, SLOT_A } from '../../data/slotPool'

export const HIDDEN_MAX = SLOT_X.length + SLOT_Y.length + SLOT_Z.length + SLOT_A.length

const BASE32_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'

export interface SlotTuple {
  x: number
  y: number
  z: number
  a: number
}

export function encodeHash(tuple: SlotTuple): string {
  // pack four 7-bit indices into a 28-bit number
  const bits = ((tuple.x & 0x7F) << 21)
    | ((tuple.y & 0x7F) << 14)
    | ((tuple.z & 0x7F) << 7)
    | (tuple.a & 0x7F)

  let hash = ''
  for (let i = 5; i >= 0; i--) {
    hash += BASE32_CHARS[(bits >> (i * 5)) & 0x1F]
  }
  return hash
}

export function decodeHash(hash: string): SlotTuple | null {
  if (!hash || hash.length !== 6) return null

  let bits = 0
  for (let i = 0; i < 6; i++) {
    const idx = BASE32_CHARS.indexOf(hash[i].toUpperCase())
    if (idx === -1) return null
    bits = (bits << 5) | idx
  }

  const x = (bits >> 21) & 0x7F
  const y = (bits >> 14) & 0x7F
  const z = (bits >> 7) & 0x7F
  const a = bits & 0x7F

  // validate against pool sizes
  if (x >= SLOT_X.length || y >= SLOT_Y.length || z >= SLOT_Z.length || a >= SLOT_A.length) {
    return null
  }

  return { x, y, z, a }
}
